export const getDistinctBedroomCounts = (floorPlans = []) => {
  const counts = new Set();
  (floorPlans || []).forEach((floorPlan) => {
    if (floorPlan?.nBeds !== null && floorPlan?.nBeds !== undefined) {
      counts.add(floorPlan.nBeds);
    }
  });
  return Array.from(counts).sort((a, b) => a - b);
};

// Some waitlist columns hold several values as one comma-joined string, e.g.
// "HUD, LIHTC" or "1 Bedroom, 2 Bedrooms".
export const splitCommaList = (value: ?string): Array<string> =>
  (value ?? '')
    .split(',')
    .map((program) => program.trim())
    .filter(Boolean);

// Matches a row when any of its comma-joined values is selected.
export const commaListColumnTableFilterFn = (
  selectedValues: string | Array<string>,
  value: ?string,
): boolean => {
  const rowValues = splitCommaList(value).map((rowValue) =>
    rowValue.toLowerCase(),
  );

  return [selectedValues]
    .flat()
    .filter(Boolean)
    .some((selectedValue) => rowValues.includes(selectedValue.toLowerCase()));
};
